import { render } from "./ylyUploadjuliang.vue?vue&type=template&id=b248bf54&scoped=true"
import script from "./ylyUploadjuliang.vue?vue&type=script&lang=js"
export * from "./ylyUploadjuliang.vue?vue&type=script&lang=js"

import "./ylyUploadjuliang.vue?vue&type=style&index=0&id=b248bf54&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b248bf54"]])

export default __exports__